/**
 * What a viewer's keyboard does on the canvas. A viewer looks, so the keys that move the view work
 * and every key that would write (delete, nudge, paste, group, undo, a tool's letter) does nothing:
 * the server refuses what they write, and a key that appeared to work would only be taken back.
 */
export type ViewKey = 'zoom-in' | 'zoom-out' | 'fit' | 'actual-size';

export function viewKeyOf(event: { key: string; metaKey: boolean; ctrlKey: boolean; altKey: boolean }): ViewKey | null {
  if (event.altKey) return null;
  const meta = event.metaKey || event.ctrlKey;
  if (meta) {
    if (event.key === '=' || event.key === '+') return 'zoom-in';
    if (event.key === '-' || event.key === '_') return 'zoom-out';
  }
  // 0 and 1 are the zoom keys with ⌘ held and bare.
  if (event.key === '0') return 'fit';
  if (event.key === '1') return 'actual-size';
  return null;
}
